var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"items":_vm.feedTanks,"fields":_vm.overviewFields,"hover":"","striped":""},on:{"row-clicked":_vm.onFeedTankClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }